// get Firestore database instance
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/storage";

const db = firebase
  .initializeApp({
    apiKey: "AIzaSyARXOOmxxhDTPPvalJIUTfnRn81FEKPHb4",
    authDomain: "westenddiamond-730e3.firebaseapp.com",
    databaseURL: "https://westenddiamond-730e3.firebaseio.com",
    projectId: "westenddiamond-730e3",
    storageBucket: "westenddiamond-730e3.appspot.com",
    messagingSenderId: "363364112055",
    appId: "1:363364112055:web:1fe5ec17a4a1c10311df32",
    measurementId: "G-K2ZCR160W5"
  })
  .firestore();

firebase
  .firestore()
  .enablePersistence()
  .then(() => {
    console.log("PERSISTENT STORAGE ENABLED");
  })
  .catch(function(err) {
    if (err.code == "failed-precondition") {
      // Multiple tabs open, persistence can only be enabled
      // in one tab at a a time.
      // ...
    } else if (err.code == "unimplemented") {
      // The current browser does not support all of the
      // features required to enable persistence
      // ...
    }
  });

const { Timestamp, GeoPoint } = firebase.firestore;

export { db, firebase, Timestamp, GeoPoint };
